import { IComponentOptions } from 'angular';
import { CreditGapsTransferStepperCtrl } from './credit-gaps-transfer-stepper.controller';

export const CreditGapsTransferStepperComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    courseDiffs: '<',
  },
  controller: CreditGapsTransferStepperCtrl,
  template: require('./credit-gaps-transfer-stepper.html'),
};
